/* eslint no-unused-vars: 0 */
/* eslint camelcase: 0 */

import { Gestacao } from './entity/Gestacao';
import { PlanoDeSaude } from './entity/PlanoDeSaude';
import { ConsultaColetiva } from './entity/ConsultaColetiva';
import { Paciente } from './entity/Paciente';
import { Grupo } from './entity/Grupo';
import { Internacao } from './entity/Internacao';
import { Consulta } from './entity/Consulta';
import { NotaProntuario } from './entity/NotaProntuario';

// ENUMS
// =================================
export enum EscolaridadePaciente {
  EFI = 'EFI', // Ensino Fundamental Incompleto
  EFC = 'EFC', // Ensino Fundamental Completo
  EMI = 'EMI', // Ensino Médio Incompleto
  EMC = 'EMC', // Ensino Médio Completo
  ESI = 'ESI', // Ensino Superior Incompleto
  ESC = 'ESC', // Ensino Superior Completo
}

export enum SimNaoNaoSei {
  S = 'S', // Sim
  N = 'N', // Não
  X = 'X', // Não sei
}

export enum SimNao {
  S = 'S', // Sim
  N = 'N', // Não
}

export enum EstadoCivilPaciente {
  S = 'S', // Solteira
  C = 'C', // Casada
  U = 'U', // União Estável
  O = 'O', // Outro
}

export enum EstadosBrasil {
  AC = 'AC',
  AL = 'AL',
  AP = 'AP',
  AM = 'AM',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MT = 'MT',
  MS = 'MS',
  MG = 'MG',
  PA = 'PA',
  PB = 'PB',
  PR = 'PR',
  PE = 'PE',
  PI = 'PI',
  RJ = 'RJ',
  RN = 'RN',
  RS = 'RS',
  RO = 'RO',
  RR = 'RR',
  SC = 'SC',
  SP = 'SP',
  SE = 'SE',
  TO = 'TO',
  EX = 'EX',
}

export enum SexoBebe {
  F = 'F', // Feminino
  M = 'M', // Masculino
  S = 'S', // Surpresa
  X = 'X', // Indefinido
}

export enum TipoHistorico {
  P = 'P', // Pessoal
  F = 'F', // Familiar
  G = 'G', // Ginecológico
  H = 'H', // Hábitos
}

export enum TipoTelefone {
  W = 'W', // WhatsApp
  C = 'C', // Celular
  F = 'F', // Fixo
}

export enum TipoConsulta {
  P = 'P', // Presencial
  R = 'R', // Remota
}

export enum Edema {
  '1+' = '1+',
  '2+' = '2+',
  '3+' = '3+',
  '4+' = '4+',
}

export enum ApresentacaoFetal { // APRESENTAÇÃO FETAL
  C = 'C', // Cefálico
  P = 'P', // Pélvico
  T = 'T', // Transversa
  X = 'X', // Indefinido
}

export enum PosicaoFetal { // POSIÇÃO FETAL
  E = 'E', // Esquerda
  D = 'D', // Direita
  A = 'A', // Anterior
  P = 'P', // Posterior
  X = 'X', // Indefinido
}

export enum MovimentoFetal { // MOVIMENTO FETAL
  P = 'P', // Positivo
  N = 'N', // Negativo
  I = 'I', // Indetectável
}

export enum DppFinal {
  M = 'M', // A partir da DUM (Data da Última Menstruação)
  U = 'U', // A partir da DPP US (Data Provável de Parto do Ultrassom)
}

export enum TipoParto {
  N = 'N', // Normal
  C = 'C', // Cesárea
  A = 'A', // Aborto
}

export enum RupturaBolsa {
  ESPONTANEA_FORA_TP = 'Espontânea fora de TP',
  ESPONTANEA_INICIO_TP = 'Espontânea no início do TP',
  ESPONTANEA_FIM_TP_EXPULSIVO = 'Espontânea no fim do TP ou expulsivo',
  NASCEU_EMPELICADO = 'Nasceu empelicado',
  ARTIFICIAL = 'Artificial',
  IGNORADO = 'Ignorado',
}

export enum DuracaoPeriodoExpulsivo {
  'MENOS_30MIN' = '< 30min',
  '30MIN_1H' = '30min a 1h',
  '1H_2H' = '1h a 2h',
  '2H_3H' = '2h a 3h',
  '3H_4H' = '3 a 4h',
  '4H_5H' = '4 a 5h',
}

export enum SangramentoPosParto {
  NORMAL = 'Normal',
  AUMENTADO_SEM_SINT = 'Aumentado mas sem sintomas',
  AUMENTADO_COM_SINT = 'Aumentado e com sintomas',
}

export enum PartoNaAgua {
  BANHEIRA = 'Banheira',
  CHUVEIRO = 'Chuveiro',
  FORA_DAGUA = "Fora d'água",
}

// Enum com valores propostos. Pode ser outra string
export enum PosicaoParto {
  SEMI_SENTADA_BANHEIRA = 'Semi sentada na banheira',
  SEMI_SENTADA_CAMA = 'Semi sentada na cama',
  SENTADA_BANQUETA = 'Sentada na banqueta',
  COCORAS_SEM_BANQUETA = 'Cócoras SEM banqueta',
  QUATRO_APOIOS = 'Quatro apoios',
  AJOELHADA = 'Ajoelhada',
  DEITADA_DE_LADO = 'Deitada de lado',
  EM_PE = 'Em pé',
  LITOTOMIA = 'Litotomia',
}

export enum ManobraDequitacao {
  DEQUITACAO_EXPONTANEA = 'Dequitação expontânea',
  TRACAO_COM_MASSAGEM = 'Tração controlada com massagem uterina',
  OCITOCINA_CORDAO = 'Ocitocina no cordão umbilical',
  CURAGEM_CURETAGEM = 'Curagem ou curetagem',
}

// Enum com valores propostos. Pode ser outra string
export enum IndicacaoCesarea {
  PELVICO = 'Pélvico',
  DESPROPORCAO_CEFALO_PELVICA = 'Desproporção céfalo pélvica',
  FREQ_CARD_FETAL = 'Frequência cardíaca fetal não tranquilizadora',
  PEDIDO_MATERNO = 'Pedido materno',
  FALHA_INDUCAO = 'Falha de indução',
  PROLAPSO_CORDAO = 'Prolapso de cordão',
  DESCOLAMENTO_PLACENTA = 'Descolamento de placenta',
  PRE_ECLAMPSIA_PIORA_QUADRO = 'Pré eclâmpsia com piora do quadro',
}

export enum HppQuantidade {
  '500_800ML' = 'Entre 500 e 800 ml',
  '800_1200ML' = 'Entre 800 e 1200 ml',
  '1200_2000ML' = 'Entre 1200 e 2000 ml',
  'MAIS_2000ML' = 'Mais de 2000 ml',
}

export enum Clampeamento {
  'MAIS_10MIN' = 'Mais que 10 minutos',
  '3MIN_10MIN' = 'ntre 3 e 10 minutos',
  '1MIN_3MIN' = 'Entre 1 e 3 minutos',
  'MENOS_1MIN_IMEDIATO' = 'Antes de 1 minuto ou imediato',
}

export enum Encaminhamento {
  ALOJAMENTO_CONJUNTO = 'Alojamento Conjunto',
  BERCARIO = 'Berçário',
  UTI_NEONATAL = 'UTI Neonatal',
}

// Enum com valores propostos. Pode ser outra string
export enum Amamentacao {
  PRIMEIRA_HORA = '1ª hora de vida',
  SEGUNDA_HORA = '2ª hora de vida',
}

export enum TipoConsultaColetiva {
  A = 'AGENDADA',
  F = 'FINALIZADA',
  C = 'CANCELADA',
}

export enum StatusExame {
  '-' = '-', // NEGATIVO
  '+' = '+', // POSITIVO
  'I' = 'I', // IMUNE
  'N' = 'N', // NORMAL
  'A' = 'A', // ALTERADO
  'S' = 'S', // SOLICITADO
}

export enum PlacentaLocalizacao {
  A = 'A', // ANTERIOR
  P = 'P', // POSTERIOR
  L = 'L', // LATERAL
  F = 'F', // FÚNDICA
  V = 'V', // PRÉVIA
}

export enum NormalAlterado {
  N = 'N',
  A = 'A',
}

export enum Acompanhamento {
  COLETIVO = 'COLETIVO',
  PARTICULAR = 'PARTICULAR',
  CASA_DE_PARTO = 'CASA_DE_PARTO',
}

export enum Egb {
  P = 'P',
  N = 'N',
  X = 'X',
}

export enum TipoInformacaoParto {
  EVOLUCAO = 'EVOLUCAO',
  VISITA = 'VISITA',
}

export enum MomentoMedicaoGlicemia {
  JE = 'JE', // Jejum
  PC = 'PC', // Pós-café
  PA = 'PA', // Pós-almoço
  PJ = 'PJ', // Pós-jantar
  AV = 'AV' // Avulso
}

export enum IntervaloRefeicao {
  '1h' = '1h',
  '2h' = '2h',
}

export enum PeriodoMedicaoPressao {
  M = 'M', // Manhã
  T = 'T', // Tarde
  N = 'N', // Noite
}

export enum PosturaMedicaoPressao {
  S = 'S', // Sentada
  D = 'D', // Decubito Lateral Esquerdo
}

export enum TipoNotaProntuario {
  NOTA_EXAME = 'NE',
  CONSULTA_REMOTA = 'CR',
  REVISAO_PRONTUARIO = 'RP',
}

export enum TipoConsultaOuNotaProntuario {
  CONSULTA_PRESENCIAL = 'CP',
  NOTA_EXAME = 'NE',
  CONSULTA_REMOTA = 'CR',
  REVISAO_PRONTUARIO = 'RP',
}

// TYPES
// =================================

export interface ConsultaOuNotaProntuario {
  id: number,
  data: Date,
  tipo: TipoConsultaOuNotaProntuario,
  consulta?: Consulta,
  nota_prontuario: NotaProntuario,
}

export interface ResponseObj<T> {
  status?: number,
  errors: string[]
  data: T
}

export interface PacienteAba {
  paciente_id: number,
  aba: number,
}

export interface ConfirmarOptions {
  title: string,
  text: string,
}

export interface AvisoSnackbarOptions {
  color?: string
  text: string | string[],
  timeout?: number,
}

export interface OpcaoStatus {
  status: string,
  color: string,
}

export interface UsuarioAuth {
  id: number,
  nome: string,
  email: string,
  token: string,
  grupo: Grupo,
  paciente_id?: number | null,
  permissoes: Object,
}

export interface ItemExameResultado {
  id: number,
  nome: string,
  grupoExameId: number | null,
  resultadosData: any,
  resultadosTrimestre: any,
  sizeData: number,
}

export interface UsuarioLoginFormData {
  email: string,
  senha: string,
}

export interface UsuarioNovoFormData {
  nome: string,
  email: string,
  senha: string
  token: string,
}

export interface UsuarioEditFormData {
  id: number,
  nome: string,
  email: string,
  grupo_id: number,
  ativo: boolean,
}

export interface RedefinirSenhaFormData {
  senha: string
  token: string,
}

export interface EsqueciMinhasSenhaFormData {
  email: string,
}

export interface ConviteUsuarioNovoFormData {
  email: string,
}

export interface UsuarioPacienteFormData {
  email: string,
  senha: string
  token: string,
}

export interface ConvitePacienteFormData {
  paciente_id: number,
  email: string,
}

export interface ConvitePacienteQueryObj {
  paciente_id?: number,
  token?: string,
}

export interface UsuarioQueryObj {
  paciente_id?: number,
  grupo_id?: number[],
  ativo?: string, // 'true' / 'false'
}

export interface MedicoesQueryObj {
  gestacao_id: number,
}

export interface GestacaoFormData extends Gestacao {
  altura_cm?: number | null,
}

export interface GestacaoFinalizarFormData {
  Gestacao: {
    id: number,
    medico: string | null,
    pediatra: string | null,
    doula: string | null,
    fotografa: string | null,
    local_parto: string | null,
    // BEBE 1
    nome1: string | null,
    sexo1: SexoBebe | null,
    // BEBE 2
    nome2?: string | null,
    sexo2?: SexoBebe | null,
  },
  Parto: {
    paciente_id: number,
    tipo_parto: TipoParto,
    data_parto: Date,
    ruptura_bolsa: RupturaBolsa,
    duracao_periodo_expulsivo: DuracaoPeriodoExpulsivo,
    sangramento_pos_parto: SangramentoPosParto,
    observacoes?: string | null,
    // PARTO NORMAL
    parto_na_agua?: PartoNaAgua | null,
    posicao_parto?: string | null,
    tempo_dequitacao?: number | null,
    manobra_dequitacao?: ManobraDequitacao | null,
    laceracao?: number | null,
    sutura?: boolean | null,
    // CESAREA
    indicacao_cesarea?: string | null,
    // ABORTO
    ig_aborto_semanas?: number | null,
    // OCORRENCIAS
    ocorrencia_hpp: boolean,
    hpp_quantidade?: string | null,
    ocorrencia_induzido: boolean,
    ocorrencia_analgesia: boolean,
    ocorrencia_vacuo: boolean,
    ocorrencia_forceps: boolean,
    ocorrencia_ruptura: boolean,
    ocorrencia_ocitocina: boolean,
    ocorrencia_episiotomia: boolean,
    ocorrencia_kristeller_pressao_fundica: boolean,
    ocorrencia_uti_materna: boolean,
    ocorrencia_transfusao: boolean,
    ocorrencia_distocia_ombros: boolean,
    // BEBE 1
    peso1_gramas: number,
    apgar1_1: number,
    apgar1_2: number,
    apgar1_3?: number | null,
    clampeamento1: Clampeamento,
    contato_pele1: boolean,
    contato_pele1_justificativa?: string | null,
    amamentacao1?: string | null,
    encaminhamento1: Encaminhamento,
    encaminhamento1_justificativa?: string | null,
    intercorrencias1?: string | null,
    // BEBE 2
    peso2_gramas?: number | null,
    apgar2_1?: number | null,
    apgar2_2?: number | null,
    apgar2_3?: number | null,
    clampeamento2?: Clampeamento | null,
    contato_pele2?: boolean | null,
    contato_pele2_justificativa?: string | null,
    amamentacao2?: string | null,
    encaminhamento2?: Encaminhamento | null,
    encaminhamento2_justificativa?: string | null,
    intercorrencias2?: string | null,
  }
}

export interface GestacaoFinalizadaAlterarFormData {
  Gestacao: {
    id: number,
    medico: string | null,
    pediatra: string | null,
    doula: string | null,
    fotografa: string | null,
    local_parto: string | null,
    // BEBE 1
    nome1: string | null,
    sexo1: SexoBebe | null,
    // BEBE 2
    nome2?: string | null,
    sexo2?: SexoBebe | null,
  },
  Parto: {
    id: number,
    paciente_id: number,
    tipo_parto: TipoParto,
    data_parto: Date,
    ruptura_bolsa: RupturaBolsa,
    duracao_periodo_expulsivo: DuracaoPeriodoExpulsivo,
    sangramento_pos_parto: SangramentoPosParto,
    observacoes?: string | null,
    // PARTO NORMAL
    parto_na_agua?: PartoNaAgua | null,
    posicao_parto?: string | null,
    tempo_dequitacao?: number | null,
    manobra_dequitacao?: ManobraDequitacao | null,
    laceracao?: number | null,
    sutura?: boolean | null,
    // CESAREA
    indicacao_cesarea?: string | null,
    // ABORTO
    ig_aborto_semanas?: number | null,
    // OCORRENCIAS
    ocorrencia_hpp: boolean,
    hpp_quantidade?: string | null,
    ocorrencia_induzido: boolean,
    ocorrencia_analgesia: boolean,
    ocorrencia_vacuo: boolean,
    ocorrencia_forceps: boolean,
    ocorrencia_ruptura: boolean,
    ocorrencia_ocitocina: boolean,
    ocorrencia_episiotomia: boolean,
    ocorrencia_kristeller_pressao_fundica: boolean,
    ocorrencia_uti_materna: boolean,
    ocorrencia_transfusao: boolean,
    ocorrencia_distocia_ombros: boolean,
    // BEBE 1
    peso1_gramas: number,
    apgar1_1: number,
    apgar1_2: number,
    apgar1_3?: number | null,
    clampeamento1: Clampeamento,
    contato_pele1: boolean,
    contato_pele1_justificativa?: string | null,
    amamentacao1?: string | null,
    encaminhamento1: Encaminhamento,
    encaminhamento1_justificativa?: string | null,
    intercorrencias1?: string | null,
    // BEBE 2
    peso2_gramas?: number | null,
    apgar2_1?: number | null,
    apgar2_2?: number | null,
    apgar2_3?: number | null,
    clampeamento2?: Clampeamento | null,
    contato_pele2?: boolean | null,
    contato_pele2_justificativa?: string | null,
    amamentacao2?: string | null,
    encaminhamento2?: Encaminhamento | null,
    encaminhamento2_justificativa?: string | null,
    intercorrencias2?: string | null,
  }
}

export interface GestacaoAnteriorFormData {
  Gestacao: {
    paciente_id: number,
    atual: boolean,
    gestacao_anterior: boolean,
    gestacao_gemelar: boolean,
    ig_semanas: number | null,
    ig_dias: number | null,
    nome1: string | null,
    sexo1: SexoBebe | null,
    nome2?: string | null,
    sexo2?: SexoBebe | null,
    ended: Date,
  },
  Parto: {
    paciente_id: number,
    data_parto: Date | null,
    tipo_parto: string | null,
    peso1_gramas: number | null,
    peso2_gramas?: number | null,
    observacoes: string | null,
  },
}

export interface GestacaoAlteraResponsavelFormData {
  responsavelId: number;
  gestacoesIds: number[];
}

export interface PlanoDeSaudeForm {
  key: number,
  id: number | null,
  nome: string,
  tipo: string,
  fimCarencia: SimNaoNaoSei,
  preferido: SimNao,
  remover: boolean,
}

export interface PlanoDeSaudeFormData extends PlanoDeSaude {
  remover: boolean,
}

export interface ConsultaSimplificada {
  paciente_id: number,
  gestacao_id: number | null,
}

export interface ConsultaColetivaPostFormData {
  datetime_agendamento: Date,
  datetime_agendamento_fim: Date,
  consultas: ConsultaSimplificada[],
}

export interface ConsultaColetivaPutFormData {
  id: number,
  observacoes?: string | null,
  datetime_agendamento?: Date,
  datetime_agendamento_fim?: Date,
  consultas?: ConsultaSimplificada[],
}

export interface ConsultaColetivaAdicionaFormData {
  id: number,
  pacientes_ids: number[],
}

export interface ConsultaColetivaIniciarFormData {
  id: number,
}

export interface ConsultaColetivaFinalizarFormData {
  id: number,
}

export interface ConsultaColetivaCancelarFormData {
  id: number,
  justificativa_cancelamento: string,
}

export interface ConsultasColetivasPaginatedData {
  registros: ConsultaColetiva[],
  total_registros: number,
}

export interface PacientesPaginatedData {
  registros: Paciente[],
  total_registros: number,
}

export interface InternacoesPaginatedData {
  registros: Internacao[],
  total_registros: number,
}

export interface GestacoesPaginatedData {
  registros: Gestacao[],
  total_registros: number,
}

export interface ConsultaPostFormData {
  tipo_consulta: TipoConsulta,
  paciente_id: number,
  gestacao_id: number | null,
  datetime_agendamento?: Date,
  // consultas remotas
  queixas_condutas?: string,
  started?: Date,
  started_by?: number,
}

export interface NotaProntuarioCriarFormData {
  paciente_id: number,
  gestacao_id?: number | null,
  tipo_nota: TipoNotaProntuario,
  nota: string,
  responsavel_id?: number | null,
  data_nota: Date,
}

export interface NotaProntuarioAlterarFormData {
  id: number,
  tipo_nota: TipoNotaProntuario,
}

export interface ConsultaPutFormData {
  id: number,
  datetime_agendamento?: Date,
  nome_atendente?: string | null,
  justificativa_cancelamento?: string,
  presenca_consulta_coletiva?: boolean,
  peso_gramas?: number | null,
  altura_uterina?: number | null,
  freq_card_materna?: number | null,
  movimento_fetal?: MovimentoFetal | null,
  edema?: Edema | null,
  queixas_condutas?: string | null,
  queixas_condutas_privada?: boolean,
  pedidos_exames?: string | null,
  mamas?: string | null,
  bat_card_fetal1?: number | null,
  apres_fetal1?: ApresentacaoFetal,
  posicao_fetal1?: PosicaoFetal,
  bat_card_fetal2?: number | null,
  apres_fetal2?: ApresentacaoFetal,
  posicao_fetal2?: PosicaoFetal,
  pressoes_arteriais?: PressaoArterialForm[],
  gestacao?: {
    id: number,
    obs_pre_natal?: string | null,
  },
}

export interface ConsultaAlterarQueixasCondutasPrivadaFormData {
  id: number,
  queixas_condutas_privada?: boolean,
}

export interface PressaoArterialForm {
  id: number | null,
  max: number,
  min: number,
  observacoes: string | null,
  created: Date | null,
  remover: boolean,
  nome_criador?: string,
}

export interface PacientePutFormData {
  id: number,
  cpf?: string,
  rg?: string,
  nome?: string,
  email?: string,
  data_nascimento?: Date | null,
  profissao?: string,
  escolaridade?: EscolaridadePaciente,
  estado_civil?: EstadoCivilPaciente,
  estado_civil_outro?: string | null,
  telefone1?: string,
  tipo_telefone1?: TipoTelefone,
  telefone2?: string | null,
  tipo_telefone2?: TipoTelefone | null,
  condicoes_especiais?: string | null,
  exames?: string | null,
  como_conheceu?: string | null,
  parceiro_nome?: string | null,
  parceiro_telefone?: string | null,
  parceiro_tipo_telefone?: TipoTelefone | null,
  parceiro_profissao?: string | null,
  parceiro_escolaridade?: EscolaridadePaciente,
  cep?: string,
  logradouro?: string,
  numero?: string,
  complemento?: string | null,
  bairro?: string | null,
  cidade?: string,
  estado?: EstadosBrasil,
  pais?: string,
  status_observacoes?: number,
  observacoes?: string | null,
  dados_financeiros?: string | null,
  acompanhamento?: Acompanhamento | null,
  responsavel_id?: number | null,
  justificativa_cancelamento?: string | null,
  gestacoes_anteriores?: Gestacao[],
}

export interface PacientePostFormData {
  cpf: string,
  rg: string,
  nome: string,
  email: string,
  data_nascimento: Date | null,
  profissao: string,
  escolaridade: EscolaridadePaciente,
  estado_civil: EstadoCivilPaciente,
  estado_civil_outro: string | null,
  telefone1: string,
  tipo_telefone1: TipoTelefone,
  telefone2: string | null,
  tipo_telefone2: TipoTelefone | null,
  condicoes_especiais?: string | null,
  exames?: string | null,
  gestacoes_anteriores?: string | null,
  como_conheceu: string | null,
  parceiro_nome?: string | null,
  parceiro_telefone?: string | null,
  parceiro_tipo_telefone?: TipoTelefone | null,
  parceiro_profissao?: string | null,
  parceiro_escolaridade?: EscolaridadePaciente,
  cep?: string,
  logradouro?: string,
  numero?: string,
  complemento?: string | null,
  bairro?: string | null,
  cidade?: string,
  estado?: EstadosBrasil,
  pais?: string,
  gestacoes?: {
    atual: boolean,
    dpp_final: DppFinal | null,
    data_ultima_menstruacao: Date | null,
    data_provavel_parto: Date | null,
  }[],
  planos_de_saude?: {
    nome: string,
    tipo: string,
    fim_carencia: SimNaoNaoSei,
    preferido: boolean,
  }[],
}

export interface HistoricoHelper {
  historicoId: number,
  show: boolean,
  verTodas: boolean,
}

export interface HistoricoRespostaFormData {
  id: number,
  historico_id: number,
  historico_pergunta_id: number,
  resposta: string | null,
  observacoes: string | null,
}

export interface ResultadoDeExameFormData {
  id?: number | null,
  exame_id: number | null,
  nome_exame?: string | null,
  gestacao_id: number | null,
  paciente_id: number,
  consulta_id?: number | null,
  status: string | null,
  observacoes?: string | null,
  data_exame?: Date | null,
  resultado?: string | null,
}

// STORE FORMS
// =================================
export interface PacienteFormExterno {
  Etapa1: PacienteFormExternoEtapa1,
  Etapa2: PacienteFormExternoEtapa2,
  Etapa3: PacienteFormExternoEtapa3,
  Etapa4: PacienteFormExternoEtapa4,
}

export interface PacienteFormExternoEtapa1 {
  cpf: string,
}

export interface PacienteFormExternoEtapa2 {
  nome: string,
  email: string,
  rg: string,
  dataNascimentoFormatada: string,
  dataNascimento: string,
  estadoCivil: EstadoCivilPaciente,
  estadoCivilOutro: string,
  profissao: string,
  escolaridade: EscolaridadePaciente,
  telefone1: string,
  telefone2: string,
  tipoTelefone1: string,
  tipoTelefone2: string,
}

export interface PacienteFormExternoEtapa3 {
  cep: string,
  logradouro: string,
  numero: string,
  complemento: string,
  bairro: string,
  cidade: string,
  estado: string,
  pais: string,
}

export interface PacienteFormExternoEtapa4 {
  planoSaude: string,
  nomePlanoSaude: string,
  tipoPlanoSaude: string,
  fimCarenciaParto: string,
  gestacao: string,
  dataUltimaMenstruacao: string,
  dataProvavelParto: string,
  condicoesEspeciaisItems: any,
  condicoesEspeciaisOutras: string,
  condicoesEspeciais: string,
}

export interface VacinacoesFormData {
  id?: number;
  paciente_id: number,
  gestacao_id?: number | null,
  vacina_id?: number | null,
  nome_vacina: string,
  data_vacinacao: Date | null,
}

export interface ResultadoExameSoftDeleteFormData {
  id: number,
  justificativa: string | null,
}

export interface VacinacaoSoftDeleteFormData {
  id: number,
  justificativa: string | null,
}

export interface UltrassomFormData {
  id?: number;
  paciente_id: number,
  gestacao_id?: number | null,
  data_ultrassom: Date,
  ig_semanas: number,
  ig_dias: number,
  placenta_localizacao?: PlacentaLocalizacao | null,
  placenta_grau?: number | null,
  observacoes?: string | null,
  ila1?: number | null,
  doppler1?: NormalAlterado | null,
  peso_gramas1?: number | null,
  morfologia1?: NormalAlterado | null,
  apres_fetal1?: ApresentacaoFetal,
  sexo1?: SexoBebe | null,
  ila2?: number | null,
  doppler2?: NormalAlterado | null,
  peso_gramas2?: number | null,
  morfologia2?: NormalAlterado | null,
  apres_fetal2?: ApresentacaoFetal,
  sexo2?: SexoBebe | null,
}

export interface GruposResultadosExamesForm {
  grupoExameId: number | null,
  grupoExameNome: string,
  grupoExameOrdem: number,
  nomesExamesConcat: string,
  resultadosDeExamesItems: ResultadoDeExameFormItem[],
}

export interface ResultadoDeExameFormItem {
  exameId: number | null,
  exameLabel: string,
  exameTexto: string | null,
  nomeExame: string | null,
  ordem: number,
  resultado: string,
  opcoesResultados: { value: string, text: string }[] | null,
  status: string | null,
  opcoesStatus: { value: string, text: string, color: string }[] | null,
  observacoes: string | null,
}

export interface InformacaoPartoFormData {
  id?: number;
  paciente_id: number,
  internacao_id: number | null,
  tipo: TipoInformacaoParto,
  datetime_informacao: Date,
  responsavel_id: number,
  observacoes: string,
}

export interface InternacaoNovaFormData {
  paciente_id: number;
  gestacao_id: number | null;
  local: string;
  quarto: string | null;
  motivo: string;
  datetime_agendamento: Date | null;
  datetime_internacao: Date | null;
}

export interface InternacaoEditFormData {
  id: number;
  local: string;
  quarto: string | null;
  motivo: string;
  egb: Egb | null,
  datetime_agendamento: Date | null;
  datetime_internacao: Date | null;
}

export interface InternacaoIniciarFormData {
  id: number;
  datetime_internacao: Date;
}

export interface InternacaoPreverAltaFormData {
  id: number;
  data_previsao_alta: string;
}

export interface InternacaoSuspenderAltaFormData {
  id: number;
}

export interface InternacaoConfirmarAltaFormData {
  id: number;
}

export interface InternacaoCancelarFormData {
  id: number;
  justificativa_cancelamento: string;
}

export interface MedicaoGlicemiaCriarFormData {
  paciente_id: number;
  data_medicao: string;
  momento: MomentoMedicaoGlicemia;
  intervalo_refeicao: IntervaloRefeicao;
  medida: number;
  observacoes?: string;
}

export interface MedicaoGlicemiaAlterarFormData {
  id?: number;
  paciente_id: number;
  data_medicao: string;
  momento: MomentoMedicaoGlicemia;
  intervalo_refeicao: IntervaloRefeicao;
  medida: number;
  observacoes?: string;
}

export interface MedicaoGlicemiaExcluirFormData {
  id: number;
  justificativa: string;
}

export interface MedicaoPressaoArterialCriarFormData {
  paciente_id: number;
  data_medicao: string;
  periodo: PeriodoMedicaoPressao,
  postura: PosturaMedicaoPressao,
  max: number;
  min: number;
  observacoes?: string;
}

export interface MedicaoPressaoArterialAlterarFormData {
  id?: number;
  paciente_id: number;
  data_medicao: string;
  periodo: PeriodoMedicaoPressao,
  postura: PosturaMedicaoPressao,
  max: number;
  min: number;
  observacoes?: string;
}

export interface MedicaoPressaoArterialExcluirFormData {
  id: number;
  justificativa: string;
}

export interface DocumentoCriarFormData {
  paciente_id: number;
  nome_original: string;
  mimetype: string;
  tamanho: number;
  detalhes?: string | null;
}

export interface DocumentoAlterarFormData {
  id: number;
  detalhes?: string | null;
}

// FRONT END PERMISSIONS

export interface FrontEndPermissions {
  Consulta: {
    agendar: boolean,
    atender: boolean,
    cancel: boolean,
    create_remota: boolean,
    end: boolean,
    view: boolean,
    view_finalizadas: boolean,
  },
  ConsultaColetiva: {
    agendar: boolean,
    cancelar: boolean,
    edit: boolean,
    iniciar: boolean,
    view: boolean,
  },
  ConviteUsuario: {
    create: boolean,
    delete: boolean,
    resend: boolean,
  },
  Gestacao: {
    create: boolean,
    create_anterior: boolean,
    edit: boolean,
    end: boolean,
    view: boolean,
    view_carteira_pre_natal: boolean,
    alterar_responsavel: boolean,
  },
  Grupo: {
    view: boolean,
  },
  Historico: {
    edit: boolean,
    view: boolean,
  },
  Home: {
    view: boolean
  },
  InformacaoParto: {
    view: boolean,
    create: boolean,
  },
  Internacao: {
    view: boolean,
    create: boolean,
    edit: boolean,
  },
  MedicaoGlicemia: {
    view_index: boolean,
    create: boolean,
    delete: boolean,
  },
  NotaProntuario: {
    create: boolean,
    view: boolean,
    edit: boolean,
  },
  Paciente: {
    create: boolean,
    edit_condicoes_especiais: boolean,
    edit_dados_gerais: boolean,
    edit_endereco: boolean,
    edit_financeiro: boolean,
    view_cadastro: boolean,
    view_condicoes_especiais: boolean,
    view_financeiro: boolean,
    view_index: boolean,
    view_resumo: boolean,
    view_gestantes: boolean,
    view_medicoes: boolean,
    view_documentos: boolean,
    view_prontuario_completo: boolean,
    view_observacoes: boolean,
    create_documentos: boolean,
  },
  PlanoDeSaude: {
    create: boolean,
    delete: boolean,
    edit: boolean,
  },
  PressaoArterial: {
    create: boolean,
    delete: boolean,
  },
  ResultadoDeExame: {
    create: boolean,
    create_pedido: boolean,
    delete: boolean,
    delete_pedido: boolean,
    edit: boolean,
    restore: boolean,
    view: boolean,
    view_removidos: boolean,
  },
  TextoEditavel: {
    edit: boolean,
    view: boolean,
  },
  Ultrassom: {
    create: boolean,
    edit: boolean,
    view: boolean,
  },
  Usuario: {
    view: boolean,
    edit: boolean,
  },
  Vacinacao: {
    create: boolean,
    delete: boolean,
    edit: boolean,
    restore: boolean,
    view: boolean,
    view_removidas: boolean,
  },
}
